import { ArrowRight } from "lucide-react";

export default function FrameworkEvents() {
    return (
        <div data-testid="framework-events-page">
            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-12">
                <div className="fw-label mb-4">Events</div>

                <h1 className="fw-display text-5xl sm:text-7xl leading-none">
                    Coming{" "}
                    <span className="text-[#a6ce39]">
                        Soon.
                    </span>
                </h1>

                <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/60">
                    Great tennis is better together. Framework open
                    drills and special events are coming soon.
                </p>
            </section>

            <div className="fw-rule max-w-[1400px] mx-auto" />

            <section className="max-w-[1400px] mx-auto grid gap-6 px-6 py-16 lg:grid-cols-2 lg:px-10 lg:py-20">
                <article className="fw-card flex flex-col p-7 sm:p-9">
                    <div className="fw-label mb-4">
                        Upcoming
                    </div>

                    <h2 className="fw-display text-3xl sm:text-4xl">
                        Open Drills &amp; Events
                    </h2>

                    <p className="mt-5 flex-1 leading-relaxed text-white/60">
                        Open drills and special events are coming soon.
                        Be the first to hear when new opportunities are
                        announced.
                    </p>

                    <a
                        href="/framework/contact?type=event-interest"
                        className="fw-btn-primary mt-8 inline-flex w-fit items-center gap-2"
                        data-testid="fw-event-interest"
                    >
                        Keep Me Posted
                        <ArrowRight size={18} strokeWidth={2.5} />
                    </a>
                </article>

                <article className="fw-card flex flex-col p-7 sm:p-9">
                    <div className="fw-label mb-4">
                        Custom Events
                    </div>

                    <h2 className="fw-display text-3xl sm:text-4xl">
                        Bring Framework To You.
                    </h2>

                    <p className="mt-5 leading-relaxed text-white/60">
                        Have courts and players? Framework can build a
                        professionally organized tennis experience for
                        your club, HOA, school, park, neighborhood,
                        team, or private group.
                    </p>

                    <p className="mt-5 flex-1 text-sm leading-relaxed text-white/45">
                        Open drills, team practices, fundraisers, school
                        programs, community clinics, and custom special
                        events can be designed around your group.
                    </p>

                    <a
                        href="/framework/contact?type=host-event"
                        className="fw-btn-outline mt-8 inline-flex w-fit items-center gap-2"
                        data-testid="fw-plan-event"
                    >
                        Plan an Event
                        <ArrowRight size={18} strokeWidth={2.5} />
                    </a>
                </article>
            </section>
        </div>
    );
}
